import { Component } from '@angular/core';
import {
    CustomerFragment,
    CustomerHistoryEntryComponent,
    SharedModule,
    TimelineDisplayType,
    TimelineHistoryEntry,
} from '@vendure/admin-ui/core';

@Component({
    selector: 'fulfillment-update-entry',
    template: `
    <ng-container *ngIf="entry">
        <div class="title">
            Imported Fulfillment
        </div>
        <div class="details">
            <div><strong>Fulfillment ID:</strong> {{ entry.data.fulfillmentId }}</div>
            <div><strong>Carrier:</strong> {{ entry.data.carrier || 'N/A' }}</div>
            <div><strong>Service:</strong> {{ entry.data.service || 'N/A' }}</div>
            <div><strong>Tracking Code:</strong> {{ entry.data.trackingCode || 'N/A' }}</div>
        </div>
    </ng-container>
    `,
    standalone: true,
    imports: [SharedModule],
})
export class FulfillmentUpdateHistoryEntryComponent implements CustomerHistoryEntryComponent {
    entry: TimelineHistoryEntry;
    customer: CustomerFragment;

    getDisplayType(entry: TimelineHistoryEntry): TimelineDisplayType {
        return 'success';
    }

    getName(entry: TimelineHistoryEntry): string {
        return `${entry.administrator?.firstName} ${entry.administrator?.lastName}`;
    }

    isFeatured(entry: TimelineHistoryEntry): boolean {
        return true;
    }

    getIconShape(entry: TimelineHistoryEntry) {
        return 'truck';
    }

}